interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1,
  );

  return (
    <nav aria-label="分页导航" className="mt-8 flex items-center justify-center gap-1.5 flex-wrap">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="h-8 px-3 rounded-md border border-background-300 text-[12px] text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((p, index) => (
        <span key={p} className="flex items-center gap-1.5">
          {index > 0 && p - pages[index - 1] > 1 ? (
            <span className="text-[12px] text-foreground-400 px-1">…</span>
          ) : null}
          <button
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === page ? "page" : undefined}
            className={`w-8 h-8 rounded-md text-[12px] transition-colors cursor-pointer ${
              p === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:bg-background-100"
            }`}
          >
            {p}
          </button>
        </span>
      ))}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="h-8 px-3 rounded-md border border-background-300 text-[12px] text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}